import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const RoofId = iotsUtils.fromList(constants.job.ancillaryItem.roofIds);

export const FloorId = iotsUtils.fromList(constants.job.ancillaryItem.floorIds);

export const FrameId = iotsUtils.fromList(constants.job.ancillaryItem.frameIds);

export const EwpId = iotsUtils.fromList(constants.job.ancillaryItem.ewpIds);

export const WholeHouseId = iotsUtils.fromList(constants.job.ancillaryItem.wholeHouseIds);

export const MultiLevelWholeHouseId = iotsUtils.fromList(
	constants.job.ancillaryItem.multiLevelWholeHouseIds
);

export const Id = iotsUtils.fromList(constants.job.ancillaryItem.ids);
